import React  from "react";
import './examBack.css'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';
import block2 from '../../assets/products/block2.png'

class OfflineClassSch extends React.Component  {
    constructor(props)
  {super(props); }

    getDayName = (dayIndex) => {
        const days = {
            0: this.props.t('calendar.days.sunday'),
            1: this.props.t('calendar.days.monday'),
            2: this.props.t('calendar.days.tuesday'),
            3: this.props.t('calendar.days.wednesday'),
            4: this.props.t('calendar.days.thursday'),
            5: this.props.t('calendar.days.friday'),
            6: this.props.t('calendar.days.saturday')
        };
        return days[dayIndex] || '';
    }
    each_month_digit_value_all_mixed = {"Jan":1,"Feb":2,"March":3,"Mar":3,"April":4,"Apr":4,"May":5,"Jun":6,"June":6,"Jul":7,"July":7,"Aug":8,"Sep":9,"Sept":9,"Oct":10,"Nov":11,"Dec":12,"January":1,"February":2,"March":3,"April":4,"May":5,"June":6,"July":7,"August":8,"September":9, "October":10,"November":11,"December":12}

 subjectList(object)
 {
     var subject_marks_array=[]
     var subject_marks_string=""
     var only_subject_string=""
     var subject_marks_and_only_subject_name_combined_array=[]
   for (var r in object)
   {   subject_marks_array.push(object[r].subject_name+":"+object[r].marks_obtained+"/"+object[r].total_marks+",   ")
       subject_marks_string=subject_marks_string+(object[r].subject_name+" : "+object[r].marks_obtained+" / "+object[r].total_marks+",      ")
       only_subject_string=only_subject_string+(object[r].subject_name+", ")
   }
        subject_marks_and_only_subject_name_combined_array.push(subject_marks_string)
        subject_marks_and_only_subject_name_combined_array.push(only_subject_string)
        return subject_marks_and_only_subject_name_combined_array
 }

render()
{
    return(
    <>

        <div className="entire_off_exam_container" style={{wordBreak:"break-word", }} >
            <div className="offline-exam-details" >
                <div className="off-exam">
                    <div className="off-exam-date" style={{ width:"25%" }} >
                        <span>{this.props.list_element.exam_date?this.props.list_element.exam_date:""}                                 
                        {this.props.list_element.exam_date
                            ?
                            (" "+this.getDayName(
                                new Date
                                    (this.props.list_element.exam_date.split("-")[2],
                                    this.each_month_digit_value_all_mixed[this.props.list_element.exam_date.split("-")[1]]-1,
                                    this.props.list_element.exam_date.split("-")[0],).getDay() ))
                            :
                            ""     
                        }
                        </span>
                        <span className="off-heading2">{this.props.list_element.start_time?this.props.list_element.start_time:""}- {this.props.list_element.end_time?this.props.list_element.end_time:""} </span>
                    </div>
                    <div
  className="offline-result"
  style={{ width: "30%" }} // keep Attendance+Marks stable

>                        <div className="off-div">
                            <span className="off-heading"  >{this.props.t('examReports.attendance')}</span>
                            <span className="off-image"  style={{width:"100%",marginLeft:"0"}}>
                                <center> 
                                    <div  style={ this.props.list_element.attendance_status && this.props.list_element.attendance_status=="P"
                                        ?
                                        {width:"20px",minWidth:"20px",borderRadius:"5px",background:"#61C611",color:"white",padding:"2px"}
                                        :
                                        this.props.list_element.attendance_status && this.props.list_element.attendance_status!="P"
                                        ? {width:"20px",minWidth:"20px",borderRadius:"5px",background:"#FF4A4E",color:"white",padding:"2px"} :{} } >
                                         {this.props.list_element.attendance_status?this.props.list_element.attendance_status:"-"}
                                    </div>
                                </center>
                            </span>
                        </div>
                        <div className="off-div"     style={{ 
   display: "flex",
    alignItems: "center",
  width: "30%"  // shrink if Rank visible
  }} // expand when no Rank
>
  <span className="off-heading">{this.props.t('examReports.marks')}</span>
  

  <span className="off-heading2" style={{ width: "60px" ,display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",}}>
    {(() => {
      const list = this.props.list_element;
      const hasCourseLevelMarks =
        list.courseLevelMarksObtain != null &&
        (list.courseLevelMarksObtain || list.courseLevelMarksObtain === 0) &&
        list.courseLevelTotalMarks != null &&
        list.courseLevelTotalMarks >= 0;

      if (hasCourseLevelMarks && list.courseLevelMarksObtain > 0) {
        return `${list.courseLevelMarksObtain}/${list.courseLevelTotalMarks}`;
      } else if (
        Array.isArray(list.subjectWiseExamSchdList) &&
        list.subjectWiseExamSchdList.length > 0
      ) {
        const obtained = list.subjectWiseExamSchdList.reduce(
          (sum, sub) =>
            sub.marks_obtained != null && !isNaN(sub.marks_obtained)
              ? sum + Number(sub.marks_obtained)
              : sum,
          0
        );
        const total = list.subjectWiseExamSchdList.reduce(
          (sum, sub) =>
            sub.total_marks != null && !isNaN(sub.total_marks)
              ? sum + Number(sub.total_marks)
              : sum,
          0
        );
        return `${obtained}/${total}`;
      } else {
        return "-";
      }
    })()}
  </span>
</div>


{this.props.show_exam_rank && (
  <div className="off-div">
    <span className="off-heading">{this.props.t('examReports.rank')}</span>
    <span style={{ display: "flex" }} className="off-heading2">
      {(() => {
        const list = this.props.list_element;

        if (list.isAbsent === "Y") {
          return "-";
        }
        const subjectWiseList = Array.isArray(list.subjectWiseExamSchdList)
          ? list.subjectWiseExamSchdList
          : [];

        // If subject-wise ranks exist and count > 1, show them
        const subjectWiseRanks = subjectWiseList
          .map((sub) => sub.rank)
          .filter((rank) => rank != null && rank !== "" && !isNaN(rank));

        if (subjectWiseRanks.length > 1) {
          return subjectWiseRanks.join(",");
        }

        // If only one subject or no subject-wise, fallback to course level
        if (
          list.courseLevelRank != null &&
          (list.courseLevelMarksObtain || list.courseLevelMarksObtain === 0)
        ) {
          return (
            <>
              {list.courseLevelRank}
              {list.courseLevelRank === 1 && (
                <img className="off-image2" src={block2} />
              )}
            </>
          );
        }

        // Else fallback
        return "-";
      })()}
    </span>
  </div>
)}




                    </div>

                    <div className="offline-result2"  style={{ 
    width: this.props.show_exam_rank ? "22%" : "25%", 
    marginLeft: "0" 
  }}>
                        <span className="off-heading">{this.props.t('examReports.subjects')}</span>
                        <span className="off-heading2">
                            {( (!this.props.list_element.subjectWiseExamSchdList ) ||  (this.props.list_element.subjectWiseExamSchdList && Object.getOwnPropertyNames(this.props.list_element.subjectWiseExamSchdList).length==0) )
                                ?
                                (this.props.list_element.subject_name && (this.props.list_element.subject_name.substr(0,24)))                          
                                :   
                                <div style={{display:"flex"}} title={this.subjectList(this.props.list_element.subjectWiseExamSchdList)[1]}>
                                    {this.subjectList(this.props.list_element.subjectWiseExamSchdList)[1].substr(0,19) }
                                    &nbsp;&nbsp;&nbsp;
                                        <div title={ this.subjectList(this.props.list_element.subjectWiseExamSchdList)[0] }
                                            style={ { border:"1px solid rgb(245, 237, 237)", borderRadius:"5px",width:"20px",color:"blue",fontWeight:"bold",fontSize:"20px",fontStretch:"ultraExpanded", cursor:"text"}  }  >
                                            <center>i</center>
                                        </div>                                     
                                </div>
                            }
                        </span>
                    </div>
                    <div className="offline-result2"  style={{ width:"15%", marginLeft:"0", }} >
                        <span className="off-heading">{this.props.auth.is_institute_type_school ? this.props.t('profile.section') : this.props.t('profile.batch')}</span>
                        <span className="off-heading2"
                            title={(this.props.element && this.props.element.course_Name)?this.props.element.course_Name:"-"}>  
                            {(this.props.element && this.props.element.course_Name.substr(0,24))?this.props.element.course_Name:"-"}
                        </span>
                    </div>
                </div>
                {!(this.props.auth.is_institute_type_school) &&
                    <div className="off-exam2-div"  >
                        <div className="offline-result2"  >
                            <span className="off-heading">{this.props.t('examReports.topicNames')}</span>
                            <span className="off-heading2" style={{width:"120px"}}
                                title={(this.props.list_element && this.props.list_element.topic_name)?this.props.list_element.topic_name:"-"}> 
                                {(this.props.list_element && this.props.list_element.topic_name)?this.props.list_element.topic_name.substr(0,24):"-"}
                            </span>
                        </div>
                        <div className="offline-result2">
                            <span className="off-heading">{this.props.t('examReports.description')}</span>
                            <span className="off-heading2" style={{width:"350px"}} title={this.props.list_element.examDesc?this.props.list_element.examDesc :"-"} >
                                {this.props.list_element.examDesc ?this.props.list_element.examDesc.substr(0,45) :"-" }
                            </span>
                        </div>              
                    </div>
                }
            </div>                   
        </div>
    </>
    )
}}
const mapStateToProps = state =>({auth:state.auth})
export default connect(mapStateToProps)(withTranslation()(OfflineClassSch))